module.exports = __webpack_public_path__ + "img/img_industries.61eb7d0a.jpg";